import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  ...theme.paddings(40, 15, 60, 15),

  [theme.down("sm")]: {
    ...theme.paddings(20, 10, 40, 10),
  },
}));

export const Card = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 640,
  ...theme.paddings(30),
  display: "flex",
  flexDirection: "column",
  gap: 20,
  borderRadius: 12,
  backgroundColor: theme.palette.white,
  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",

  [theme.down("sm")]: {
    ...theme.paddings(20, 15),
    boxShadow: "none",
  },
}));

export const Title = styled("h1")(({ theme }) => ({
  margin: 0,
  fontSize: 28,
  color: "#333",
  textAlign: "center",
  fontWeight: 700,

  [theme.down("md")]: {
    fontSize: 22,
  },
}));

export const Subtitle = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 15,
  lineHeight: 1.5,
  color: "#666",
  textAlign: "center",
}));

export const Fields = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 15,
}));

export const Row = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 15,

  [theme.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const OrderInfo = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 10,
  ...theme.paddings(12, 15),
  borderRadius: 8,
  backgroundColor: "#f5f7fa",
  fontSize: 14,
  color: "#333",

  "& b": {
    fontSize: 16,
  },
}));

export const FormError = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 15),
  borderRadius: 6,
  backgroundColor: theme.palette.input.errorBg,
  border: `1px solid ${theme.palette.input.borderError}`,
  color: theme.palette.input.errorText,
  fontSize: 14,
}));

export const SubmitButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(0, 15),
  width: "100%",
  position: "relative",
  fontSize: 18,
  border: "none",
  borderRadius: 4,
  backgroundColor: theme.palette.searchButtonBg,
  color: theme.palette.white,
  height: 46,
  cursor: "pointer",
  transition: "filter .2s ease",

  "&:hover": {
    filter: "brightness(90%)",
  },

  "&:disabled": {
    opacity: 0.7,
    cursor: "default",
  },

  [theme.down("xs")]: {
    fontSize: 16,
  },
}));

export const SubmitButtonLoadingCover = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: 4,
  backgroundColor: theme.palette.searchButtonBg,
}));

export const SuccessIcon = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  alignSelf: "center",
  width: 72,
  height: 72,
  borderRadius: "50%",
  backgroundColor: "rgba(76, 175, 80, 0.12)",
  color: "#4caf50",
  fontSize: 44,
}));

export const Links = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexWrap: "wrap",
  gap: 20,

  "& a": {
    color: theme.palette.searchButtonBg,
    fontSize: 14,
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

// возврат по пассажирам: список с галочками
export const PassengersBlock = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  padding: 12,
  borderRadius: 8,
  border: "1px solid #e5e5e5",
}));

export const PassengersLabel = styled("div")(() => ({
  fontSize: 14,
  fontWeight: 600,
  color: "#333",
}));

export const PassengerRow = styled("label")(({ $disabled }) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: 15,
  color: $disabled ? "#999" : "#333",
  cursor: $disabled ? "default" : "pointer",

  "& input": {
    width: 18,
    height: 18,
    flexShrink: 0,
  },
}));

export const PassengerNote = styled("span")(() => ({
  marginLeft: "auto",
  fontSize: 13,
  color: "#999",
}));

export const PassengersHint = styled("div")(() => ({
  fontSize: 13,
  lineHeight: 1.4,
  color: "#888",
}));
